
import { LocalStorageService } from 'angular-web-storage';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from '../../login/login.service';

import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { filter, firstValueFrom } from 'rxjs';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { ReportsService } from '../_services/reports.service';
import { DatasetsFieldsService } from '../_services/datasets-fields.service';
import { DatasetField } from '../_types/dataset-field';
import { Report } from '../_types/report';
import { date } from '@rxweb/reactive-form-validators';
import { DatasetsService } from '../_services/datasets.service';

@Component({
    selector: 'app-reports-visualization',
    templateUrl: './reports-visualization.component.html',
    styleUrls: ['./reports-visualization.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ReportsVisualizationComponent implements OnInit{
  
  public rows: any[] = [];
  public datasetsFields: any[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  public lastGridEvent: any = {
    first: 0,
    rows: 0
  };
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public type: string = "";
  public report!: Report;
  public reportFields: any[] = [];  
  public showFiltersModal:boolean = false;
  public checkFilters:boolean = false;  

  public config: any = {
    filters: [{}]
  };

  public usedSnapshot: boolean = false;
  public snapshotDate: Date | null = null;

  public arrayYesNo: any = [
    {
      id: "false",
      name: "No"
    },{
      id: "true",
      name: "Sí"
    }
  ];

  public arrayDates: any = [
    {
      id: "TODAY",
      name: "Hoy"
    },{
      id: "PLUS7",
      name: "Hoy más 7 días"
    },{
      id: "LESS7",
      name: "Hoy menos 7 días"
    },{
      id: "MONTH",
      name: "Mes en curso"
    },
    {
      id: "YEAR",
      name: "Año en curso"
    },
    {
      id: "CUSTOM",
      name: "Especificar fecha"
    },

  ];

  constructor(
    private storage: LocalStorageService,
    private messageService: MessageService,    
    private confirmationService: ConfirmationService,                
    private router: Router,
    private topbarService: TopbarService,
    private loginService: LoginService,
    private reportsService: ReportsService,
    private route: ActivatedRoute,
    private datasetsFieldsService:DatasetsFieldsService,     
           
  ) {
        
    this.allowWrite = this.loginService.hasPermission("REPORTS.WRITE");
    this.allowDelete = this.loginService.hasPermission("REPORTS.DELETE");
  }

    async ngOnInit(): Promise<void> {        
  
      const params = await firstValueFrom(this.route.paramMap);
      let id: string | null = params.get('id');

      this.topbarService.setWindowTitle("GUAI - Informes");
      this.topbarService.setTitle("Visualización de informe");
      this.topbarService.addBreadcrumb("Informes", "/reports");      

      this.allowWrite = this.loginService.hasPermission("REPORTS.WRITE");
      this.allowDelete = this.loginService.hasPermission("REPORTS.DELETE");
      
      if (id != null && id !== '0') {
        await this.loadReport(id);
        
        if(!this.report.isSystem && this.allowWrite){
          this.topbarService.addAction("Editar", "pi pi-pencil", false, () => {
            this.router.navigate(['reports/' + id]);
          });
        }
  
        this.topbarService.addAction("Exportar a excel", "pi pi-file-excel", false, () => {
          this.exportToExcel(id!);
        });
      }
  
    }


    async loadReport(id: string) {
      //obtenemos el informe
      this.report = await firstValueFrom(this.reportsService.get(id));

      //cambiamos titulo
      this.topbarService.setTitle(this.report.name);

      //obtenemos los campos del dataset
      await this.loadDatasetsFields(); 

      //mapear filtros de url a informe
      this.route.snapshot.queryParamMap.keys.forEach((key: string) => {
        let value = this.route.snapshot.queryParamMap.get(key);
        
        let datasetField = this.datasetsFields.find((x: any) => x.columnName.toUpperCase() == key.toUpperCase());        
        if(datasetField!=null){
          let filter = this.config.filters.find((x: any) => x.datasetFieldId == datasetField.id);          
          if(filter!=null){
            if(datasetField.optionsSql){
              if(value!=null) filter.value = value.split(',');
            }else{
              filter.value = value;
            }
          }
        }
      });

      //asignamos campo a la ocnfiguracion del informe
      this.report.reportConfig.columns.forEach((column: any) => {
        let datasetField = this.datasetsFields.find((x: any) => x.id == column.datasetFieldId);
        if(datasetField!=null) column.datasetField = datasetField;
      });  
      
      //cargamos los resultados
      this.loadResults();
    }

    async loadDatasetsFields() {
      let filter: any = { 
        dataset_id: new Filter(FilterOperation.equals, 'datasetId', '', this.report.datasetId)
      };
      let response = await firstValueFrom(this.datasetsFieldsService.all({ filter: FilterBuilder.fromObject(filter).build() }));     
      this.datasetsFields = response.data;            
      await this.loadFilters();
    }

  hasSumarizedColumns(): boolean {
    return this.report.reportConfig.columns.filter((col: any) => (col.summarize != null && col.summarize != '')).length > 0;
  }

  getSummarizedValue(column: any): any {
    if(column.summarize == 'SUM'){
      let sum = 0;
      this.rows.forEach(row => {
        let value = this.getRowValue(row, column);
        if(value != null && value != ''){
          if(typeof value == 'string') value = value.replace(',', '.');
          sum += Number(value);
        }
      });
      return parseFloat(sum.toFixed(2));
    }else if(column.summarize == 'AVG'){
      let sum = 0;
      let nValues = 0;
      this.rows.forEach(row => {
        let value = this.getRowValue(row, column);
        if(value != null && value != ''){
          if(typeof value == 'string') value = value.replace(',', '.');
          sum += Number(value);
          nValues++;
        }
      });
      return parseFloat((sum / nValues).toFixed(2));
    }
    return '';
  }

  exportToExcel(id: string) {
    //this.reportsService.getXlsx(id);

    let filters= this.convertArrayValuesToString(JSON.parse(JSON.stringify(this.config.filters)));  
    //cada valor de tipo calendar, revisamos si es CUSTOM para enviar la fecha correcta
    var correcto = true;
    filters.forEach((filter: any) => {
      if(filter.dataType == 'date' || filter.dataType == 'datetime'){
        if(filter.value == 'CUSTOM'){
          if(filter.value_data != null) {
            filter.value = filter.value_data;
          }else{
            correcto = false;
            this.messageService.add({ closable: true, severity: 'error', detail: "Debe especificar una fecha para el filtro '" + filter.datasetFieldLabel + "'" });
            return;
          }
        }else{
          delete filter.value_data;
        }
      }
    });

    this.reportsService.downloadExcel(id,this.report.name!, this.convertArrayValuesToString(JSON.parse(JSON.stringify(filters))));
  }

  async loadData($event: any) {    
    
    this.lastGridEvent = $event;

    let params:IParamsCollection = {      
      page: { number: $event.first+1, size: $event.rows },            
    }            
    let page:number = $event.first/$event.rows;
    let pageSize:number = $event.rows;
    let sortBy:string = "";
    let sortDirection:string = "asc";
    if(typeof $event.sortField != "undefined"){
      sortBy = $event.sortField;
      sortDirection = $event.sortOrder > 0 ? "asc" : "desc";
    }
    
    let filters= this.convertArrayValuesToString(JSON.parse(JSON.stringify(this.config.filters)));  

    //cada valor de tipo calendar, revisamos si es CUSTOM para enviar la fecha correcta
    var correcto = true;
    filters.forEach((filter: any) => {
      if(filter.dataType == 'date' || filter.dataType == 'datetime'){
        if(filter.value == 'CUSTOM'){
          if(filter.value_data != null) {
            filter.value = filter.value_data;
          }else{
            correcto = false;
            this.messageService.add({ closable: true, severity: 'error', detail: "Debe especificar una fecha para el filtro '" + filter.datasetFieldLabel + "'" });
            return;
          }
        }else{
          delete filter.value_data;
        }
      }
    });

    if(!correcto) return;
    let responseData:any = await firstValueFrom(this.reportsService.GetResults(this.report.id!, page, pageSize, sortBy, sortDirection, filters));
    
    this.rows = responseData.rows;
    this.totalRecords = responseData.totalRows;
    this.usedSnapshot = responseData.usedSnapshot || false;
    this.snapshotDate = responseData.snapshotDate ? new Date(responseData.snapshotDate) : null;
    
    //generamos scroll superior
    /*setTimeout(() => {
      let fakeScrollContainer = document.querySelector('.large-table-fake-top-scroll') as HTMLElement;
      let fakeScroll = document.querySelector('.large-table-fake-top-scroll div') as HTMLElement;
      let datatableTable = document.querySelector('.p-datatable-table') as HTMLElement;
      let datatableWrapper = document.querySelector('.p-datatable-wrapper') as HTMLElement;
      fakeScroll.style.width = datatableTable.offsetWidth + 'px';
      fakeScrollContainer.onscroll = function() {
        datatableWrapper!.scrollLeft = fakeScrollContainer.scrollLeft;
      };
      datatableWrapper.onscroll = function() {
        fakeScrollContainer!.scrollLeft = datatableWrapper.scrollLeft;
      };
    }, 1 * 1000);*/

  }

  async loadFilters(){
    if(this.report.reportConfig.filters.filter((m:any) => m.askUser == true).length >0){
      this.showFiltersModal = true;
      if (this.report.reportConfig != null ) {                
        this.config.filters = await Promise.all(
          this.report.reportConfig.filters.filter((m:any) => m.askUser == true).map(async (filter: any) => {       
            
            const datasetField = this.datasetsFields.find(df => df.id === filter.datasetFieldId);            
            const operators = datasetField ? this.operatorByType[datasetField?.optionsSql||datasetField?.optionsItems?"multiselect":datasetField.dataType] : [];
            let dropdownOptions = [];
                
            if (datasetField?.optionsSql) {
              dropdownOptions = await this.loadDropdownOptions(datasetField.id);  
              //console.log("dropdownOptions", dropdownOptions);
            }
            if(datasetField?.optionsItems){
                dropdownOptions =  JSON.parse(datasetField.optionsItems);
            }
            return {
              datasetFieldId: datasetField?.id || null,
              datasetFieldLabel: filter?.label!=null?filter?.label:datasetField?.label || null,
              operator: filter.operator,
              value: datasetField?.optionsSql ? (filter.value != "" && filter.value != null ? filter.value.split(',') : []) : filter.value,
              operators,
              dataType: datasetField?.dataType,
              dropdownOptions: Array.isArray(dropdownOptions) ? dropdownOptions : [],
              askUser: filter.askUser
            };    
                      
          })
        ); 
        this.config.filtersShow = this.config.filters;
      }
    }else{
      this.checkFilters = true;
      this.loadData(this.lastGridEvent);
    }    
  }

  async loadDropdownOptions(datasetField: string, filter: string = ""): Promise<any[]> {    
    let response = await firstValueFrom(this.datasetsFieldsService.getDropdownOptions(datasetField, {filter: filter}));
    if(response.result.length == 0){
      response.result = [{Id: null, Name: 'No se han encontrado opciones'}];
    }
    return response.result;
  }

  async onFilterDropdownOptionsChange(datasetField: string, filter: string = ""){
     var aux = this.config.filters.find((f: any) => f.datasetFieldId == datasetField);
    aux.dropdownOptions = await this.loadDropdownOptions(datasetField, filter);
  }

  async loadResults(){        
    this.loadData(this.lastGridEvent);    
  }

  getRowValue(row: any, column: any) {
    try{
      let columnName = column.datasetField?.name;
      if(columnName==null) columnName = "Col" + column.order;
      var value = row[columnName];
      if(value!=null){
        if(column.datasetField?.dataType=='date'){
          value = new Date(value).toLocaleDateString();
        }else if(column.datasetField?.dataType=='datetime'){
          value = new Date(value).toLocaleDateString() + " " + new Date(value).toLocaleTimeString();
        }else if(column.datasetField?.dataType=='bool'){
          if(column.aggregation){
            value = value;
          }else{
            value = value ? 'Si' : 'No';
          }
        }
      }else{
        value = "";
      }
      return value;
    }catch(e){
      console.error(e);
      return '(error)';
    }
  }
  
  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(report: any) {
    //if (this.loginService.hasPermission("REPORTS_WRITE")) {      
      this.router.navigate(['reports/'+ (report && Object.keys(report).length > 0 ? report.id : 0)]);
    //}
  }

  delete(report: any) {    
    if (this.allowDelete) {      
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el informe "+report.name+"?",
        header: "Eliminar informe",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.reportsService.delete(report.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Informe eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }


  convertArrayValuesToString(obj: any): any {        
    if (Array.isArray(obj)) {
      return obj
        .map(item => this.convertArrayValuesToString(item))
        .filter(item => item !== null); // Filtra elementos nulos
    } else if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        if (key === 'value' && Array.isArray(obj[key])) {
          obj[key] = obj[key].join(',');
        } else if (typeof obj[key] === 'object') {
          obj[key] = this.convertArrayValuesToString(obj[key]);
        }
      }
      // Si value es null, elimina el objeto del array
      return obj.value !== null && obj.value !== "" ? obj : null;
    }
    return obj;
  }
  
  // Operadores por tipo de dato
  operatorByType: { [key: string]: { label: string, value: string }[] } = {
    bool: [
      /*{ label: 'Igual', value: '=' },
      { label: 'Distinto', value: '!=' }*/
    ],
    string: [
      { label: 'Contiene (LIKE)', value: 'LIKE' },
      { label: 'Igual', value: '=' },
      { label: 'Distinto', value: '!=' }
    ],
    date: [
      { label: 'Mayor que', value: '>' },
      { label: 'Menor que', value: '<' },
      { label: 'Igual', value: '=' }
    ],
    number: [
      { label: 'Igual', value: '=' },
      { label: 'Distinto', value: '!=' },
      { label: 'Mayor que', value: '>' },
      { label: 'Menor que', value: '<' }
    ],
    multiselect: [
      { label: 'Contiene', value: 'IN' },
      { label: 'No contiene', value: 'NOT IN' },      
    ]
  };
}
